module.exports = __webpack_public_path__ + "static/media/didiao003.0369da3c.jpg";